module.exports = {
    gameList: [
        {
            img: require("@/assets/images/wap/news1.png"),
            link: "/game/minstrel-war.html",
            title: " MINSTREL WAR  ",
            desc:
                "Minstrel War is casual turn-based RPG game. The game is created with a fast pace and it will guarantee the gamer a light-hearted and yet joyful gaming experience.",
            full_desc:
                'Minstrel War is casual turn-based RPG game. The game is created with a fast pace and it will guarantee the gamer a light-hearted and yet joyful gaming experience.</br></br>All characters and scenes are created with hand-drawing, players who enjoyed JRPG art style would come to the right place. In the game, players will play a leader of magical mercenary squad to venture the land full of mystery, monsters and adventures. The squad will not stop their endeavor to victory even when the phone is set aside by the players, so you can always expect your squad to be fully ready when you pick your phone and ready to play!"',
            screenShotImages: [
                {
                    img: require("@/assets/images/wap/MW1.png")
                },
                {
                    img: require("@/assets/images/wap/MW2.png")
                },
            ]
        },
        {
            img: require("@/assets/images/wap/news2.png"),
            link: "/game/fantasy.html",
            title: "魔妃異聞錄：姬不可失",
            desc:
                "モテモテDevil is created with a storyline that a working-man was summoned into a digital realm and found himself become the protagonist of the game. In this Strategy RPG, the player has to deal with magical warfare, assemble resource to build and expand his castle, and lead an army whose captains are mostly anime-styled cute female fantasy creatures.",
            full_desc:
                "モテモテDevil is created with a storyline that a working-man was summoned into a digital realm and found himself become the protagonist of the game. In this Strategy RPG, the player has to deal with magical warfare, assemble resource to build and expand his castle, and lead an army whose captains are mostly anime-styled cute female fantasy creatures. </br></br>Beside slaying enemy, players will also need to compete with other Devils in the PvP arena, and try to get as many concubines, who happens to be also attractive female creatures, into your castle. Not just for pleasure, but also as a mean to strengthen your army and ultimately seek out how to guide the poor guy back to reality.",

            screenShotImages: [
                {
                    img: require("@/assets/images/wap/TL1.png")
                },
                {
                    img: require("@/assets/images/wap/TL2.png")
                },
                {
                    img: require("@/assets/images/wap/TL3.png")
                },
                {
                    img: require("@/assets/images/wap/TL4.png")
                }

            ]
        },
        {
            img: require("@/assets/images/wap/news3.png"),
            link: "/game/continent-heroes.html",
            title: " CONTINENT OF HEROES ",
            desc:'Continent of heroes, a magical fantasy turn-based RPG mobile game. In the Land of Magic that filled with greed and conflict, gamer needs to recruit as many gifted help as possible. Collect more heroes, obtain items and materials to form powerful artifacts, train and cultivate your team in order to improve you fighting strength and protect your manor.',
            full_desc: "Continent of heroes, a magical fantasy turn-based RPG mobile game. In the Land of Magic that filled with greed and conflict, gamer needs to recruit as many gifted help as possible. Collect more heroes, obtain items and materials to form powerful artifacts, train and cultivate your team in order to improve you fighting strength and protect your manor.</br></br>Take your team and confront other players in PVP arenas and numerous dungeons, experience the strong exhilaration of the intense confrontation! Join a guild to find your comrade to fight this god-forsaken land, fight with the help of a friend arm or you will never prevail!\n"
            ,

            screenShotImages: [
                {
                    img: require("@/assets/images/wap/DL1.png")
                },
                {
                    img: require("@/assets/images/wap/DL2.png")
                }
            ]
        },

        {
            img: require("@/assets/images/wap/news4.png"),
            link: "/game/mafia-gene.html",
            title: " MAFIA GENE ",
            desc:
            'MAFIA GENE is a Strategy RPG mobile game. As a leader of a little street gang Capos, you need to work your way up in the city’s crime hierarchy. Protect your own turf, take other’s commodity, hide from law enforcement, expand your reach, grow and employ more help and muscle, crush your competitors so that you can prosper the Capos family to the glory it once own. ',
            full_desc:
                'MAFIA GENE is a Strategy RPG mobile game. As a leader of a little street gang Capos, you need to work your way up in the city’s crime hierarchy. Protect your own turf, take other’s commodity, hide from law enforcement, expand your reach, grow and employ more help and muscle, crush your competitors so that you can prosper the Capos family to the glory it once own. \n' +
                '</br></br>' +
                'Mediate among cops, politician, rival gangs and bimbos, get away with running street warfare, smuggling, kidnapping, underground casino and racing. The game will keep your adrenalin high and enjoy the sensation of running the city as the crime lord.\n',
            screenShotImages: [
                {
                    img: require("@/assets/images/wap/UL1.png")
                },
                {
                    img: require("@/assets/images/wap/UL2.png")
                }
            ]
        }
    ]
};
